// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuratypesSoftwareDependencyStage } from './AuratypesSoftwareDependencyStage';
import {
  AuratypesSoftwareDependencyStageFromJSON,
  AuratypesSoftwareDependencyStageFromJSONTyped,
  AuratypesSoftwareDependencyStageToJSON,
  AuratypesSoftwareDependencyStageToJSONTyped,
} from './AuratypesSoftwareDependencyStage';
import type { AuratypesSoftwareDependencyType } from './AuratypesSoftwareDependencyType';
import {
  AuratypesSoftwareDependencyTypeFromJSON,
  AuratypesSoftwareDependencyTypeFromJSONTyped,
  AuratypesSoftwareDependencyTypeToJSON,
  AuratypesSoftwareDependencyTypeToJSONTyped,
} from './AuratypesSoftwareDependencyType';

/**
 *
 * @export
 * @interface AuratypesSoftwareDependency
 */
export interface AuratypesSoftwareDependency {
  /**
   *
   * @type {boolean}
   * @memberof AuratypesSoftwareDependency
   */
  autoGenerated?: boolean;
  /**
   *
   * @type {string}
   * @memberof AuratypesSoftwareDependency
   */
  name?: string;
  /**
   *
   * @type {AuratypesSoftwareDependencyStage}
   * @memberof AuratypesSoftwareDependency
   */
  stage?: AuratypesSoftwareDependencyStage;
  /**
   *
   * @type {AuratypesSoftwareDependencyType}
   * @memberof AuratypesSoftwareDependency
   */
  type?: AuratypesSoftwareDependencyType;
}

/**
 * Check if a given object implements the AuratypesSoftwareDependency interface.
 */
export function instanceOfAuratypesSoftwareDependency(
  value: object,
): value is AuratypesSoftwareDependency {
  return true;
}

export function AuratypesSoftwareDependencyFromJSON(
  json: any,
): AuratypesSoftwareDependency {
  return AuratypesSoftwareDependencyFromJSONTyped(json, false);
}

export function AuratypesSoftwareDependencyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuratypesSoftwareDependency {
  if (json == null) {
    return json;
  }
  return {
    autoGenerated:
      json['auto_generated'] == null ? undefined : json['auto_generated'],
    name: json['name'] == null ? undefined : json['name'],
    stage:
      json['stage'] == null
        ? undefined
        : AuratypesSoftwareDependencyStageFromJSON(json['stage']),
    type:
      json['type'] == null
        ? undefined
        : AuratypesSoftwareDependencyTypeFromJSON(json['type']),
  };
}

export function AuratypesSoftwareDependencyToJSON(
  json: any,
): AuratypesSoftwareDependency {
  return AuratypesSoftwareDependencyToJSONTyped(json, false);
}

export function AuratypesSoftwareDependencyToJSONTyped(
  value?: AuratypesSoftwareDependency | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    auto_generated: value['autoGenerated'],
    name: value['name'],
    stage: AuratypesSoftwareDependencyStageToJSON(value['stage']),
    type: AuratypesSoftwareDependencyTypeToJSON(value['type']),
  };
}
